import { useState } from 'react';
import Modal from '../../components/common/Modal';
import SearchableSelect from '../../components/common/SearchableSelect';
import { STATUS_AVALIACAO_OPCOES, VIGENCIA_MESES_PADRAO } from '../../utils/acreditacaoOpcoes';

function hoje() {
  return new Date().toISOString().slice(0, 10);
}

export default function AvaliacaoForm({ requisito, avaliacaoAtual, onClose, onSalvar }) {
  const [status, setStatus] = useState(avaliacaoAtual?.status || 'conforme');
  const [fragilidade, setFragilidade] = useState(avaliacaoAtual?.fragilidade || '');
  const [acaoProposta, setAcaoProposta] = useState(avaliacaoAtual?.acao_proposta || '');
  const [prazoAcao, setPrazoAcao] = useState(avaliacaoAtual?.prazo_acao || '');
  const [vigenciaMeses, setVigenciaMeses] = useState(avaliacaoAtual?.vigencia_meses || VIGENCIA_MESES_PADRAO);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');

  const precisaAcao = status === 'nao_conforme' || status === 'parcialmente_conforme';

  // Ao reavaliar um requisito que já tinha fragilidade/prazo de uma vez anterior, mudar o
  // status pra Conforme/Supera só ESCONDE esses campos — sem isso, o valor antigo continuava
  // no estado do formulário e era enviado junto, fazendo a avaliação "resolvida" ainda contar
  // como ação corretiva pendente (o filtro de Corretivas olha o prazo_acao da avaliação atual).
  const handleStatusChange = (novoStatus) => {
    setStatus(novoStatus);
    if (novoStatus !== 'nao_conforme' && novoStatus !== 'parcialmente_conforme') {
      setFragilidade('');
      setAcaoProposta('');
      setPrazoAcao('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setEnviando(true);
    try {
      await onSalvar({
        id_requisito: requisito.id_requisito,
        status,
        fragilidade: precisaAcao ? fragilidade || null : null,
        acao_proposta: precisaAcao ? acaoProposta || null : null,
        prazo_acao: precisaAcao ? prazoAcao || null : null,
        vigencia_meses: Number(vigenciaMeses),
        data_avaliacao: hoje(),
      });
      onClose();
    } catch (err) {
      setErro(err?.response?.data?.detail || 'Não foi possível registrar a avaliação.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Modal titulo={`Avaliar — ${requisito.codigo}`} onClose={onClose} largura={560}>
      <p style={{ fontSize: 13, color: 'var(--am-cinza-texto)', marginTop: -8, marginBottom: 18 }}>
        {requisito.texto}
      </p>

      <form className="am-form" onSubmit={handleSubmit}>
        <div>
          <div className="am-field__label mb-1">
            Status de conformidade <span style={{ color: 'var(--am-critico)' }}>*</span>
          </div>
          <SearchableSelect
            options={STATUS_AVALIACAO_OPCOES}
            value={status}
            onChange={handleStatusChange}
            required
          />
        </div>

        {precisaAcao && (
          <>
            <label className="am-field">
              <div className="am-field__label-row">
                <span className="am-field__label">
                  Fragilidade encontrada <span style={{ color: 'var(--am-critico)' }}>*</span>
                </span>
              </div>
              <textarea rows={3} value={fragilidade} onChange={(e) => setFragilidade(e.target.value)} required />
            </label>

            <label className="am-field">
              <div className="am-field__label-row">
                <span className="am-field__label">Ação proposta</span>
              </div>
              <textarea rows={3} value={acaoProposta} onChange={(e) => setAcaoProposta(e.target.value)} />
            </label>

            <label className="am-field">
              <div className="am-field__label-row">
                <span className="am-field__label">Prazo da ação corretiva</span>
              </div>
              <input type="date" value={prazoAcao} onChange={(e) => setPrazoAcao(e.target.value)} />
            </label>
          </>
        )}

        <label className="am-field">
          <div className="am-field__label-row">
            <span className="am-field__label">
              Vigência (meses até nova reavaliação) <span style={{ color: 'var(--am-critico)' }}>*</span>
            </span>
          </div>
          <input
            type="number"
            min={1}
            value={vigenciaMeses}
            onChange={(e) => setVigenciaMeses(e.target.value)}
            required
          />
        </label>

        {erro && <div className="am-field__error">{erro}</div>}

        <div className="am-form__actions">
          <button type="button" className="am-btn am-btn-outline" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" className="am-btn am-btn-dark" disabled={enviando}>
            {enviando ? 'Registrando...' : 'Registrar avaliação'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
